enum InitiativeModalMode {
  Create = 'create',
  Edit = 'edit',
}

export { InitiativeModalMode };
